import { httpGet } from "../../../../../modules/Backend";
import AdobeComboBox from "../../../../AdobeAriaLib/AdobeComboBox";
import { IOption } from "../../../../AdobeAriaLib/AdobeSelect";
import { useEffect, useState } from "react";
import AdobeValueToggle from "../../../../AdobeAriaLib/AdobeValueToggle";

interface IFormOwner {
    value: any,
    label: string
    entityName: string
    required: boolean
    onChange: Function
    disabled?: boolean
}

export default function FormOwner({ value, disabled, label, entityName, required, onChange }: IFormOwner) {
    const [options, setOptions] = useState<IOption[]>();

    function handleAccountChange(value: string) {
        const newValue = {
            belongsToCellTrak: false,
            accountId: value
        };
        onChange(newValue)
    }

    function handleBelongsToCellTrakChanged(value: any) {
        // Upon change will we end up with no account id and belongs to celltrak false?
        if (value?.belongsToCellTrak && !value?.accountId) {
            // If so, ensure that we reset state to undefined as at least one of these values is required
            onChange(undefined);
            return;
        }

        const newValue = {
            belongsToCellTrak: !(value?.belongsToCellTrak ?? false),
            accountId: undefined
        };
        onChange(newValue);
    }

    function isDisabled() {
        return disabled ?? false
    }

    async function getData() {
        try {
            const result = await httpGet(`api/${entityName}/filterData`)
            if (result.data) {
                setOptions(result.data[entityName!])
            }
        }
        catch (err) {
        }
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <div className="form-owner__wrapper">
            <p>Please select the type of outer cube you want to create</p>
            <AdobeComboBox
                value={value?.accountId}
                label={'Uplift - Choose a single account'}
                labelVisible={true}
                options={options}
                required={!value?.belongsToCellTrak}
                onChangeSelect={handleAccountChange}
                disabled={isDisabled()}
                displayRequiredRule={() => false}
                selectionMode="single" />
            <hr className="margin__none"></hr>
            <div className="form-owner__decision">
                <h2>or</h2>
            </div>
            <hr className="margin__none"></hr>
            <AdobeValueToggle value={value?.belongsToCellTrak ?? false} onChange={() => handleBelongsToCellTrakChanged(value)}
                isDisabled={isDisabled}
                label={'Returns'} />
        </div>
    )
}